App.module('MessageCenterApp', function(MessageCenterApp, App){
    'use strict';

    App.on('start', function(){
        var maxMessages = 5,
            controller = new MessageCenterApp.Messages.Controller();
        App.on('messageCenter:init', function(countMessages){
            controller.initMessageCenter(countMessages);
        });

        App.trigger('messageCenter:init', maxMessages);
    });

});